module.exports = __webpack_public_path__ + "img/card-sona.2d820cd1.webp";